module.exports = __webpack_public_path__ + "img/2039807.310a5188.png";